/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    RuntimeBlock,
    RuntimeBlockFromJSON,
    RuntimeBlockFromJSONTyped,
    RuntimeBlockToJSON,
    RuntimeBlockListAllOf,
    RuntimeBlockListAllOfFromJSON,
    RuntimeBlockListAllOfFromJSONTyped,
    RuntimeBlockListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuntimeBlockList
 */
export interface RuntimeBlockList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof RuntimeBlockList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof RuntimeBlockList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<RuntimeBlock>}
     * @memberof RuntimeBlockList
     */
    blocks: Array<RuntimeBlock>;
}

export function RuntimeBlockListFromJSON(json: any): RuntimeBlockList {
    return RuntimeBlockListFromJSONTyped(json, false);
}

export function RuntimeBlockListFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeBlockList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'blocks': ((json['blocks'] as Array<any>).map(RuntimeBlockFromJSON)),
    };
}

export function RuntimeBlockListToJSON(value?: RuntimeBlockList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'blocks': ((value.blocks as Array<any>).map(RuntimeBlockToJSON)),
    };
}


